module.exports = __webpack_public_path__ + "static/media/phone.5ece324f.webp";